import { render, staticRenderFns } from "./OptionsTable.vue?vue&type=template&id=18f5fbd9&scoped=true"
import script from "./OptionsTable.vue?vue&type=script&lang=js"
export * from "./OptionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f5fbd9",
  null
  
)

export default component.exports